<template>
  <component :is="tag" :class="[classes.text, testClassName]">
    <slot />
  </component>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { defineComponent, computed, PropType } from "vue";
import {
  BrandContext,
  FontStyle,
  injectBrand
} from "@fresh8/ad-data-composition/src/brand";

const { useStyles } = createUseStyles<"text", NonNullable<FontStyle>>({
  text: {
    fontFamily: props => props.fontFamily || "",
    fontStyle: props => props.fontStyle || "normal",
    color: props => props.color || "",
    textTransform: props => props.textTransform || "none",
    textDecoration: props => props.textDecoration || "",
    // This fixes an issue with some fonts loading in Safari
    // bigger than when they measured by fontfill in canvas
    textRendering: "optimizeSpeed"
  }
});

export default defineComponent({
  name: "StyledText",
  props: {
    tag: {
      type: String as PropType<"p" | "span" | "div">,
      required: false,
      default: "p"
    },
    fontId: {
      type: String,
      required: false,
      default: undefined
    },
    name: {
      type: String,
      required: false,
      default: ""
    },
    overrideColor: {
      type: String,
      required: false,
      default: undefined
    }
  },
  setup(props) {
    const { getFontStyle } = injectBrand() || ({} as BrandContext);

    const reactiveStyles = computed(() => {
      const fontStyles = getFontStyle(props.fontId);

      return {
        ...fontStyles,
        color: props.overrideColor ?? fontStyles.color
      };
    });
    const { classesRef } = useStyles(reactiveStyles);

    return {
      classes: classesRef,
      testClassName: computed(
        () =>
          "text-style-" +
          props.name
            .toLowerCase()
            .replace(/\s/g, "-")
            .replace(/[^A-z-]/g, "")
      )
    };
  }
});
</script>
